<template>
  <div
    v-if="isBarChartVisible || isCustomBarChartVisible || isCustomBarChartQuizTypeVisible"
    class="w-full h-full d-flex"
  >
    <QuestionImage
      v-if="isQuestionImageEnabled"
      :class="{
        'default-canvas-image-width': !slideActive.showFullImageQuestion,
        'full-canvas-image-width' : slideActive.showFullImageQuestion,
        'hide-canvas-image': !questionHasImageXLarge,
      }"
      @expandCollapseTrigger="updateQuestionImageLayoutMode"
    />
    <component
      :is="chartName"
      class="default-chart-width"
      :class="{
        'default-chart-with-image' : isQuestionImageAndHasImageXLargeEnabled,
        'full-chart' : slideActive.showFullImageQuestion,
      }"
    ></component>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import Utils from '@/util'
import constants from '@/constant'
import EventBus from '@/eventBus'

import QuestionImage from '@/components-v2/presentation-editor/middle/common/QuestionImage.vue'

export default {
  components: {
    QuestionImage,
    CustomBarChartQuizType: () => import('@/components/presentations/charts/CustomBarChartQuizType.vue'),
    CustomBarChart: () => import('@/components/presentations/charts/CustomBarChart.vue'),
  },
  data() {
    return {
      disableShowFullQuestionImage: false,
    }
  },
  computed: {
    ...mapGetters(['isPresenting', 'questionHasImageXLarge', 'isQuestionImageEnabled', 'isQuestionImageAndHasImageXLargeEnabled']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
    chartName() {
      if (this.isCustomBarChartVisible) return 'CustomBarChart'
      return 'CustomBarChartQuizType'
    },
    isBarChartVisible() {
      return this.slideActive.SlideOptions.length && !this.slideActive.slideType
    },
    isCustomBarChartVisible() {
      return this.slideActive.SlideOptions.length && (this.slideActive.slideType == 'imageChoice' || !this.slideActive.slideType)
    },
    isCustomBarChartQuizTypeVisible() {
      const { slideType, showAcceptedAnswerView } = this.slideActive
      return slideType === 'typeAnswer' && !showAcceptedAnswerView
    },
  },
  created() {
    EventBus.$on('hide-show-full-question-image', () => {
      this.disableShowFullQuestionImage = true
      this.updateSlideActiveAction({
        showFullImageQuestion: false,
      })
    })
    EventBus.$on('enable-show-full-question-image', () => {
      this.disableShowFullQuestionImage = false
    })
  },
  destroyed() {
    EventBus.$off('hide-show-full-question-image')
    EventBus.$off('enable-show-full-question-image')
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    updateQuestionImageLayoutMode() {
      if (this.disableShowFullQuestionImage) return
      if (!this.questionHasImageXLarge) return
      this.updateSlideActiveAction({
        showFullImageQuestion: !this.slideActive.showFullImageQuestion,
      })

      this.handleMixpanelTracking()
    },
    handleMixpanelTracking() {
      // eslint-disable-next-line no-nested-ternary
      const evtAction = this.slideActive.showFullImageQuestion ? 'Question image > View image' : 'Question image > View default'
      // eslint-disable-next-line max-len
      const evtCategory = this.isPresenting ? constants.eventCategories.PRESENTING_MODE : constants.eventCategories.PRESENTATION_EDITOR
      const evtLabel = this.slideActive.showFullImageQuestion ? 'Expand' : 'Collapse'
      const evtValue = ''
      // eslint-disable-next-line max-len
      const slideName = Utils.getCorrectSlideTypeName(this.slideActive.type, this.slideActive.slideType)
      Utils.mixpanelTracking(
        evtCategory,
        evtAction,
        evtLabel,
        evtValue,
        {
          slideType: slideName,
          slideId: this.slideActive.id,
          presentationId: this.presentation.id,
        },
      )
    },
  },
}
</script>

<style scoped lang='scss'>
.default-canvas-image-width {
  width: 33%;

  & ::v-deep {
    .question-image__contain {
      z-index: 400;
    }
  }
}

.full-canvas-image-width {
  width: 0;
  padding: 0;
}

.default-chart-with-image {
  width: 67% !important;
}
.full-chart {
  width: 100% !important;
}

.hide-canvas-image {
  display: none;
}
</style>
